var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "q-page",
    { attrs: { padding: "" } },
    [
      _c(
        "q-tabs",
        {
          staticClass: "shadow-1 bg-white",
          attrs: {
            color: "white",
            "text-color": "primary",
            "underline-color": "primary",
            align: "justify"
          },
          model: {
            value: _vm.tab,
            callback: function($$v) {
              _vm.tab = $$v
            },
            expression: "tab"
          }
        },
        [
          _c("q-tab", {
            attrs: {
              slot: "title",
              name: "webcasts",
              label: _vm.$t("webinars"),
              icon: "fas fa-broadcast-tower"
            },
            slot: "title"
          }),
          _c(
            "q-tab-pane",
            {
              staticClass: "q-px-md q-pb-xl q-mt-md",
              attrs: { name: "webcasts" }
            },
            [
              _vm.finished_loading
                ? _c("div", { staticClass: "row gutter-sm" }, [
                    _c(
                      "div",
                      { staticClass: "col-xs-12 col-sm-3" },
                      [_c("filter-webcasts")],
                      1
                    ),
                    _c("div", { staticClass: "col-xs-12 col-sm-9" }, [
                      _vm.banners.length > 0
                        ? _c(
                            "div",
                            { staticClass: "col-12 desktop-only" },
                            [
                              _c(
                                "q-carousel",
                                {
                                  staticClass: "text-white",
                                  attrs: {
                                    height: "200px",
                                    infinite: "",
                                    autoplay: ""
                                  }
                                },
                                _vm._l(_vm.banners, function(banner, index) {
                                  return _c("q-carousel-slide", {
                                    key: index,
                                    attrs: { "img-src": banner.image_desktop }
                                  })
                                }),
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm.banners.length > 0 && _vm.showBanner
                        ? _c(
                            "div",
                            { staticClass: "col-12 mobile-only" },
                            [
                              _c(
                                "q-carousel",
                                {
                                  staticClass: "text-white",
                                  attrs: {
                                    height: _vm.getHeight + "px",
                                    infinite: "",
                                    autoplay: ""
                                  }
                                },
                                _vm._l(_vm.banners, function(banner, index) {
                                  return _c("q-carousel-slide", {
                                    key: index,
                                    attrs: { "img-src": banner.image_mobile }
                                  })
                                }),
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _c(
                        "div",
                        { staticClass: "row gutter-md q-mt-xs" },
                        [
                          _vm._l(_vm.filteredWebcasts, function(
                            webcast,
                            index
                          ) {
                            return _c(
                              "div",
                              {
                                key: index,
                                staticClass: "col-xs-12 col-sm-12"
                              },
                              [
                                _vm.$q.platform.is.desktop
                                  ? _c("card-desktop", {
                                      key: webcast.id,
                                      attrs: { webcast: webcast },
                                      on: {
                                        subscribe_webcast: function($event) {
                                          return _vm.subscribeWebcast(webcast)
                                        }
                                      }
                                    })
                                  : _vm._e(),
                                _vm.$q.platform.is.mobile
                                  ? _c("card-mobile", {
                                      key: webcast.id,
                                      attrs: { webcast: webcast },
                                      on: {
                                        subscribe_webcast: function($event) {
                                          return _vm.subscribeWebcast(webcast)
                                        }
                                      }
                                    })
                                  : _vm._e()
                              ],
                              1
                            )
                          }),
                          _vm.filteredWebcasts.length == 0
                            ? _c(
                                "div",
                                { staticClass: "col-xs-12 col-sm-12" },
                                [
                                  _c(
                                    "q-card",
                                    [
                                      _c("q-card-title", [
                                        _vm._v(
                                          "\n                                    " +
                                            _vm._s(
                                              _vm.$t("no_webcasts_found")
                                            ) +
                                            "\n                                "
                                        )
                                      ]),
                                      _c("q-card-separator"),
                                      this.search ||
                                      this.selected_areas.length > 0 ||
                                      this.progress != "all"
                                        ? _c("q-card-main", [
                                            _vm._v(
                                              "\n                                    " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "searched_term_returned_no_results"
                                                  )
                                                ) +
                                                "\n                                "
                                            )
                                          ])
                                        : _c("q-card-main", [
                                            _vm._v(
                                              "\n                                    " +
                                                _vm._s(
                                                  _vm.$t(
                                                    "there_are_no_webcasts_avaliable_at_the_moment"
                                                  )
                                                ) +
                                                "\n                                "
                                            )
                                          ])
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        2
                      )
                    ])
                  ])
                : _vm._e(),
              _c(
                "q-inner-loading",
                { attrs: { visible: !_vm.finished_loading } },
                [
                  _c("q-spinner-dots", {
                    attrs: { size: 60, color: "secondary" }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _c(
        "q-dialog",
        {
          staticClass: "dialog-webcast",
          attrs: { "prevent-close": "" },
          scopedSlots: _vm._u([
            {
              key: "buttons",
              fn: function(props) {
                return [
                  _c("q-btn", {
                    attrs: { color: "tertiary", label: _vm.$t("cancel") },
                    on: {
                      click: function($event) {
                        return _vm.cancelSubscribeWebcast()
                      }
                    }
                  }),
                  _c("q-btn", {
                    attrs: {
                      color: _vm.getWebcastSubscribeButtonColor(),
                      label: _vm.$t(_vm.getWebcastSubscribeButton())
                    },
                    on: {
                      click: function($event) {
                        return _vm.saveSubscribeWebcast()
                      }
                    }
                  })
                ]
              }
            }
          ]),
          model: {
            value: _vm.confirm_subscribe_webcast,
            callback: function($$v) {
              _vm.confirm_subscribe_webcast = $$v
            },
            expression: "confirm_subscribe_webcast"
          }
        },
        [
          _c("span", { attrs: { slot: "title" }, slot: "title" }, [
            _vm._v(_vm._s(_vm.$t(_vm.getWebcastSubscribeTitle())))
          ]),
          _c("span", { attrs: { slot: "message" }, slot: "message" }, [
            _vm._v(
              "\n            " +
                _vm._s(
                  _vm.$t(_vm.getWebcastSubscribeText()) +
                    " " +
                    _vm.webcast.title
                ) +
                "\n        "
            )
          ]),
          !_vm.webcast.webcast_user_subscribed
            ? _c(
                "span",
                { attrs: { slot: "body" }, slot: "body" },
                [
                  _c(
                    "q-field",
                    [
                      _c("q-checkbox", {
                        attrs: {
                          label: _vm.$t("receive_emails_about_this_webcast")
                        },
                        model: {
                          value: _vm.check_emails_webcast,
                          callback: function($$v) {
                            _vm.check_emails_webcast = $$v
                          },
                          expression: "check_emails_webcast"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            : _vm._e()
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }